var $373fa018f3091841$exports = {};
$373fa018f3091841$exports = {
    "help": `\u{B3C4}\u{C6C0}\u{B9D0}`,
    "info": `\u{C815}\u{BCF4}`
};


export {$373fa018f3091841$exports as default};
//# sourceMappingURL=ko-KR.mjs.map
